import React, { Suspense } from "react";
import { Route, Switch } from "react-router-dom";

import { ForgotPasswordForm, PasswordReset } from "components/pages/ForgotPassword";
import { Loading } from "components/simple";
import { Header } from "components/simple";
import Login from "../components/pages/Login";
import ProtectedRoutes from "./ProtectedRoutes";
import PostDuoRedirect from "components/pages/Login/PostDuoRedirect";

const Routes: React.FC = () => (
  <>
    <Header />
    <Switch>
      <Route path="/login" component={Login} />
      <Route path="/post_duo_login/:savedUserName/:savedState" component={PostDuoRedirect} />
      <Route path="/forgot_password" component={ForgotPasswordForm} />
      <Route path="/reset" component={PasswordReset} />
      <Suspense fallback={<Loading />}>
        <ProtectedRoutes />
      </Suspense>
    </Switch>
  </>
);

export default Routes;
